var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"has-tooltip-left",attrs:{"data-tooltip":`Last modified by ${_vm.name} on ${_vm.displayDatetime}`}},[_c('fa-icon',{staticClass:"item-icon info-icon",attrs:{"icon":"info-circle"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }